<h3>Contrat : {{ contract().employeeLastname + ' ' + contract().employeeFirstname }}</h3>
<app-contract-deleted-warning [contract]="contract()"></app-contract-deleted-warning>
<div class="flex-row">
  <app-label-value
    label="Créé le"
    [value]="contract().createdAt | date: 'medium'"
  ></app-label-value>
  <app-label-value
    label="par"
    [value]="contract().createdBy ? (contract().createdBy | userIdToUserName) : 'Inconnu'"
  ></app-label-value>
  <app-label-value
    label="débute le"
    [value]="contract().startDate | date: 'mediumDate'"
  ></app-label-value>
</div>

<div class="filters" role="group" aria-label="Filtrer par origine">
  @for (filter of filters(); track filter.key) {
    <button
      type="button"
      [attr.data-tour-anchor]="
        filter.key === amendmentKey ? 'contract-history.amendment-filter' : null
      "
      [class.selected]="filter.key === selected()"
      [attr.aria-pressed]="filter.key === selected()"
      (click)="select(filter.key)"
    >
      {{ filter.label }} · {{ filter.count }}
    </button>
  }
</div>

<div class="feed">
  <section data-testid="upcoming" aria-labelledby="history-upcoming">
    <h4 id="history-upcoming">À venir — si rien ne change</h4>
    @for (entry of upcoming(); track entry.id) {
      <app-history-entry-view [entry]="entry" />
    } @empty {
      <p class="empty">Rien de programmé.</p>
    }
  </section>

  <section data-testid="past" aria-labelledby="history-past">
    <h4 id="history-past">Ce qui a eu lieu</h4>
    @for (entry of past(); track entry.id) {
      <app-history-entry-view
        class="entry"
        [attr.data-tour-anchor]="
          entry.origin.key === amendmentKey ? 'contract-history.amendment-entry' : null
        "
        [entry]="entry"
      />
    } @empty {
      <p class="empty">Aucune entrée.</p>
    }
  </section>
</div>

@if (notes().length) {
  <div class="notes">
    @for (note of notes(); track note) {
      <p>{{ note }}</p>
    }
  </div>
}
